import React, { ReactNode, FC, useContext, useRef, useState } from 'react';

import useResize from '../../../hooks/_useResize';
import MainContentContext from '../_MainContentContext';
import { StyledWrapper, StyledContent } from './FullWidthMainContentZone.styles';

export interface FullWidthMainContentZoneProps {
  /** Content */
  children: ReactNode;
}

const FullWidthMainContentZoneDefaults = {};

/**
 * @mode developer
 */
const FullWidthMainContentZone: FC<FullWidthMainContentZoneProps> = ({ children, ...props }) => {
  const wrapperRef = useRef<HTMLDivElement>();
  const [wrapperWidth, setWrapperWidth] = useState(0);
  const { contentWidth } = useContext(MainContentContext);

  useResize(wrapperRef, () => {
    setWrapperWidth(wrapperRef.current?.clientWidth);
  }, { delay: 10 });

  return (
    <StyledWrapper ref={wrapperRef}>
      <StyledContent
        contentWidth={contentWidth}
        wrapperWidth={wrapperWidth}
        {...props}
      >
        {children}
      </StyledContent>
    </StyledWrapper>
  );
};

FullWidthMainContentZone.defaultProps = FullWidthMainContentZoneDefaults;

export default FullWidthMainContentZone;
